/** Preserve editable upstream captions without duplicating video, audio or generated code. */
export function captionSourceDocument(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== "object")
    throw Error("기존 자막 자료가 없습니다.");
  const raw = value as Record<string, unknown>;
  const entries =
    raw.items && typeof raw.items === "object" ? Object.entries(raw.items) : [];
  const items = Object.fromEntries(
    entries.filter(
      ([, v]) =>
        v && typeof v === "object" && "type" in v && v.type === "captions",
    ),
  );
  const assets = Object.fromEntries(
    Object.entries((raw.assets ?? {}) as object).filter(
      ([, v]) =>
        v && typeof v === "object" && "type" in v && v.type === "caption",
    ),
  );
  const tracks = Array.isArray(raw.tracks)
    ? raw.tracks
        .map((t) => ({
          ...t,
          items: Array.isArray(t.items)
            ? t.items.filter((key: string) => key in items)
            : [],
        }))
        .filter((t) => t.items.length)
    : [];
  return {
    version: raw.version,
    saved: raw.saved,
    fps: raw.fps,
    compositionWidth: raw.compositionWidth,
    compositionHeight: raw.compositionHeight,
    durationInFrames: Math.max(
      1,
      ...Object.values(items).map((item) => {
        const clip = item as Record<string, unknown>;
        return typeof clip.from === "number" &&
          typeof clip.durationInFrames === "number"
          ? clip.from + clip.durationInFrames
          : 1;
      }),
    ),
    backgroundColor: raw.backgroundColor,
    items,
    assets,
    tracks,
    transitions: {},
    deletedAssets: [],
    mask: null,
  };
}
